import React from "react";
import { ArrowDownIcon, FileQuestionIcon } from "lucide-react";
import { practiceQuestions, scatteredItems, systemFlow } from "../../data/content";
import { SectionHeading } from "../ui/SectionHeading";
import { TransformCta } from "../ui/TransformCta";
export function Problem() {
  return <section className="bg-white px-5 py-16 sm:py-24" aria-labelledby="problem-title" data-id="element-244" data-mp="2mptzk2fkwv3h">
      <div id="problem-title" data-id="element-245" data-mp="2hpz89xrw63hw">
        <SectionHeading title={<>
              Stop searching through different resources{" "}
              <em className="italic text-brand-600" data-id="element-247" data-mp="2cpt9lxn7fgqb">every time you want to practice</em>
            </>} subtitle="What if you had everything you needed to study and organize your reflexology practice in one place?" data-id="element-246" data-mp="2hra7dkae6n2o" />
      </div>

      <div className="mx-auto mt-10 max-w-2xl" data-id="element-248" data-mp="6ypk5mmazoy6">
        <p className="text-lg text-ink/80" data-id="element-249" data-mp="6xefzloy4f6j">When you're learning reflexology, it's easy to accumulate information.</p>
        <ul className="mt-5 space-y-2.5" data-id="element-250" data-mp="1x8ms1312kmc">
          {scatteredItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-cream px-4 py-3.5 text-lg font-medium text-ink/80" data-id="element-251" data-mp="14d6drm3lgqzf">
              <FileQuestionIcon className="h-5 w-5 shrink-0 text-ink/40" aria-hidden="true" data-id="element-252" data-mp="vanbp47muie8" />
              {item}
            </li>)}
        </ul>

        <p className="mt-8 text-lg text-ink/80" data-id="element-253" data-mp="109qjgwezz2pw">And then, when it's time to actually practice, you still find yourself asking:</p>
        <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2" data-id="element-254" data-mp="1s0mwbx1257d6">
          {practiceQuestions.map(q => <p key={q} className="rounded-xl border-l-4 border-rose-400 bg-rose-50 px-4 py-3.5 font-serif text-xl font-bold italic text-ink" data-id="element-255" data-mp="1e9hq2c36pgtv">
              “{q}”
            </p>)}
        </div>

        <p className="mt-8 text-lg leading-relaxed text-ink/80" data-id="element-256" data-mp="26xdmrgsr78qn">
          That's exactly why I created <strong className="text-brand-800" data-id="element-257" data-mp="2bodl8qhityv9">REFLEXOLOGY 360°™</strong>. I didn't want to
          create another theory-heavy ebook. I wanted to create a{" "}
          <strong className="text-ink" data-id="element-258" data-mp="2ljufm8hh7cua">visual reference system</strong> that helps you go from:
        </p>
      </div>

      <ol className="mx-auto mt-8 flex max-w-4xl flex-col items-stretch gap-2 md:flex-row md:items-center md:gap-3" data-id="element-259" data-mp="2gjooctf4bscq">
        {systemFlow.map((step, i) => <React.Fragment key={step} data-id="element-260" data-mp="26mjxwhe8paq4" data-mpi={i}>
            <li className="flex flex-1 items-center justify-center gap-3 rounded-2xl bg-brand-700 px-5 py-4 text-white" data-id="element-261" data-mp="26ppknpzec0io">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white/15 text-sm font-bold" data-id="element-262" data-mp="1xuhzsprn86j0">{i + 1}</span>
              <span className="text-lg font-extrabold uppercase tracking-wide" data-id="element-263" data-mp="1swq9g06ncsgx">{step}</span>
            </li>
            {i < systemFlow.length - 1 && <ArrowDownIcon className="mx-auto h-5 w-5 text-brand-500 md:-rotate-90" aria-hidden="true" data-id="element-264" data-mp="1ixr7t1katx3f" />}
          </React.Fragment>)}
      </ol>
      <p className="mt-6 text-center font-serif text-2xl font-bold text-brand-800" data-id="element-265" data-mp="1ewyyy9fc9u7o">All from one place.</p>

      <TransformCta label="Yes! I want my Reflexology 360° system" data-id="element-266" data-mp="3qllnqizqtjnj" />
    </section>;
}